import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_indicator",
  "use": "sort_indicator-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"sort_indicator\"><path d=\"M6 2.44 3.47 4.97c-.29.29-.29.77 0 1.06s.77.29 1.06 0l.72-.72V15c0 .41.34.75.75.75s.75-.34.75-.75V5.31l.72.72c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06zM12 15.75l2.53-2.53c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-.72.72V3.19c0-.41-.34-.75-.75-.75s-.75.34-.75.75v9.69l-.72-.72a.74.74 0 0 0-.53-.22c-.19 0-.38.07-.53.22-.29.29-.29.77 0 1.06z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol